import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { HomeComponent } from './home/home.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { JwtInterceptor } from './interceptors/jwt.interceptor';
import { LoginComponent } from './security/login/login.component';
import { FormsModule } from '@angular/forms';
import { ImportsListComponent } from './imports/imports-list/imports-list.component';
import { ReportsListComponent } from './reports/reports-list/reports-list.component';
import { ScheduleViewComponent } from './schedule/schedule-view/schedule-view.component';
import { DashboardViewComponent } from './dashboard/dashboard-view/dashboard-view.component';
import { ForgotPasswordComponent } from './security/forgot-password/forgot-password.component';
import { NewPasswordComponent } from './security/new-password/new-password.component';
import { CorsInterceptor } from './interceptors/cors.interceptor';
import { ChangePasswordComponent } from './security/change-password/change-password.component';

@NgModule({
  exports: [
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ImportsListComponent,
    ReportsListComponent,
    ScheduleViewComponent,
    DashboardViewComponent,
    ForgotPasswordComponent,
    NewPasswordComponent,
    ChangePasswordComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FontAwesomeModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [
    HttpClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    HttpClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorsInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
